import React from 'react';
import { Button } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Checkbox from '@material-ui/core/Checkbox';
import $ from "jquery";

import Loading from '../../loading';
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';

class Stockaudit extends React.Component {

  state = {
    search: '',
    allow: '0',
    fullWidth: true,
    maxWidth: 'lg',
    data: this.props.data
  }

  convertToNumber(value) {
    try {
      value = Number(value);
    } catch (e) {
      value = 0;
    }
    return value;
  }

  handleChange = (name, value) => event => {
    if (name == 'item') {
      if (event.target.checked == true) {
        this.selectItem(value);
      }
      else {
        this.deselectItem(value);
      }
    }
    else {
      if (event.target.checked == true) {
        this.selectAll();
      }
      else {
        this.deSelectAll();
      }
    }
  }

  selectItem(value) {
    let data = this.state.data;
    data.map((c) => { if (c.id == value) { c.item = true; } })
    this.setState({ data })
  }

  deselectItem(value) {
    let data = this.state.data;
    data.map((c) => { if (c.id == value) { c.item = false; } })
    this.setState({ data })
  }

  selectAll() {
    let data = this.state.data;
    data.map((c) => { c.item = true; })
    this.setState({ selectall: true, data })
  }

  deSelectAll() {
    let data = this.state.data;
    data.map((c) => { c.item = false; })
    this.setState({ selectall: false, data })
  }



  submit() {
    let context = this;
    let status = this.convertToNumber(this.props.value);
    status = status + 1;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    let items = this.state.data;
    let itemss = this.state.data;
    let newitems = [];
    items.map((c) => {
      if (c.adjustment == "2") { }
      else {
        newitems.push(c);
      }
    })
    items = JSON.stringify(newitems);
    context.setState({ load: true, message: 'Status Update!!!' })
    $.ajax({
      type: 'POST',
      data: { 'items': items, 'status': status,  'by': userId },
      url: Server() + 'stockaudit/statuschange.php',
      success: function(data)
      {
        if (data == 1) {
          itemss.map((c) => {
            newitems.map((b) => {
              if (c.id == b.id && c.item == true) {
                c.adjustment = status+'';
              }
            })
          })
          context.setState({ openDialog: false, selectall: false, data: itemss })
          context.arrangeData(itemss);
        }
        else {
          alert('Error');

        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  arrangeData(datas) {
    let data = [];
    datas.map((c) => {
      if (c.adjustment == '1' || c.adjustment == 1) {
        data.push((c));
      }
    })
    datas.map((c) => {
      if (c.adjustment == '0' || c.adjustment == 0) {
        data.push((c));
      }
    })
    datas.map((c) => {
      if (c.adjustment == '2' || c.adjustment == 2) {
        data.push((c));
      }
    })
    datas.map((c) => {
      if (c.adjustment == '-1' || c.adjustment == -1) {
        data.push((c));
      }
    })
    this.props.save(data);
  }


  render() {
    let i = 1;
    return (
      <div>
        <Button onClick={ () => { this.setState({ open: true }) }}>{this.props.title}</Button>
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.open} onClose={ () => { this.setState({ open: false }) }}
          aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">{this.props.title}</DialogTitle>
          <DialogContent>
            <table width='100%' id='table'>
              <tr id='th'>
                <th>#</th>
                <th>Spares</th>
                <th>Brand</th>
                <th>Closing Stock</th>
                <th>Branch Stock</th>
                <th>Differ</th>
                <th>
                  <center>
                    <Checkbox onChange={this.handleChange('selectall', 'value')} checked={this.state.selectall} />
                  </center>
                </th>
              </tr>
              {
                this.state.data.map((c) => {
                  let closingStock = c.closing_stock;
                  let branchStock = c.branch_stock; let differ = 0;
                  try {
                    closingStock = this.convertToNumber(closingStock);
                    branchStock = this.convertToNumber(branchStock);
                    differ = branchStock - closingStock;
                  } catch (e) { }
                  if (c.adjustment == this.props.value) {
                    return (
                      <tr>
                        <td>{i++}</td>
                        <td>{c.partno+"-->"+c.spare_name}</td>
                        <td>{c.brand_name}</td>
                        <td><center>{closingStock}</center></td>
                        <td><center>{branchStock}</center></td>
                        <td><center>{differ}</center></td>
                        <td>
                          <center>
                            <Checkbox style={{width: 10, height: 10}}
                              onChange={this.handleChange('item', c.id)}
                              checked={c.item} />
                          </center>
                        </td>
                      </tr>
                    )
                  }
                })
              }
            </table>

          </DialogContent>
          <DialogActions>
            <Button onClick={this.submit.bind(this)} color="primary">Change Status</Button>
            <Button onClick={ () => { this.setState({ open: false }) } } color="primary">Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default Stockaudit;
